import React, {FC} from 'react';

import {Checkbox} from '@optimaxdev/design-system';
import {Icon, CycleMini} from '@optimaxdev/icons';

import s from './cartSubscriptionOfferCheckbox.scss';

export type PropsType = {
    subscriptionMode: boolean;
    setSubscriptionMode: () => void;
    isDisabled: boolean;
};

/**
 * Subscription offer checkbox component for the cart item
 * @returns {React.ReactElement} - component
 */
export const CartSubscriptionOfferCheckbox: FC<PropsType> = ({
    isDisabled,
    setSubscriptionMode,
    subscriptionMode,
}) => {
    return (
        <div className={s.checkboxWrapper}>
            <div className={s.checkbox}>
                <Checkbox
                    isChecked={subscriptionMode}
                    isDisabled={isDisabled}
                    onChange={setSubscriptionMode}
                    size="medium"
                    value={String(subscriptionMode)}
                />
            </div>
            <Icon className={s.repeatIcon} icon={CycleMini} strokeWidth={2} />
            <span className={s.checkboxText}>Subscribe & Save</span>
        </div>
    );
};
